import { Button, Card, Col, Form, Input, Row, Tabs, Typography, Upload, Table, Switch, Space, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { toast } from "react-toastify";
import getSetting, { getLogoUrl } from "../../api/getSettings";

import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import Loader from "../loader/loader";
import styles from "./AddDetails.module.css";

const updateInvoice = async (values, logoFile = null) => {
  try {
    if (logoFile) {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        const v = values[key];
        if (v !== undefined && v !== null) formData.append(key, String(v));
      });
      formData.append("image", logoFile);
      await axios({
        method: "put",
        url: `setting`,
        data: formData,
        headers: { Accept: "application/json" },
      });
    } else {
      await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `setting`,
        data: { ...values },
      });
    }
    return "success";
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};

const AddDetails = () => {
  const { Title } = Typography;
  const [loader, setLoader] = useState(false);

  const [form] = Form.useForm();
  const [activeTabKey, setActiveTabKey] = useState("company");

  const [initValues, setInitValues] = useState(null);
  const [seriesByType, setSeriesByType] = useState({});
  const [seriesLoading, setSeriesLoading] = useState(false);
  const [seriesModalOpen, setSeriesModalOpen] = useState(false);
  const [seriesModalType, setSeriesModalType] = useState(null);
  const [seriesForm] = Form.useForm();

  const [fileList, setFileList] = useState([]);

  const onFinish = async (values) => {
    try {
      const newFile = fileList.find((f) => f.originFileObj);
      const clearLogo = fileList.length === 0 && initValues?.logo;
      const payload = clearLogo ? { ...values, logo: null } : values;
      const resp = await updateInvoice(payload, newFile ? newFile.originFileObj : null);
      if (resp === "success") {
        toast.success("Invoice Settings Updated Successfully");
        setInitValues({});
        window.location.reload();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Failed to update settings");
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.error("Something went wrong !");
    console.log("Failed:", errorInfo);
  };

  const onClickLoading = () => {
    setLoader(true);
  };
  useEffect(() => {
    getSetting().then((data) => {
      if (data?.result) {
        setInitValues(data.result);
        form.setFieldsValue({
          ...data.result,
          sale_invoice_terms: data.result.sale_invoice_terms || '',
          quotation_terms: data.result.quotation_terms || '',
          challan_terms: data.result.challan_terms || '',
        });
        if (data.result.logo) {
          setFileList([
            {
              uid: '-1',
              name: 'logo',
              status: 'done',
              url: getLogoUrl(data.result.logo),
            },
          ]);
        } else {
          setFileList([]);
        }
      }
    }).catch((error) => {
      console.error("Error loading settings:", error);
    });
  }, [form]);

  const loadSeries = async () => {
    setSeriesLoading(true);
    try {
      const types = ["sale_invoice", "quotation", "challan", "purchase_invoice"];
      const results = await Promise.all(
        types.map((t) => axios.get(`document-series?document_type=${encodeURIComponent(t)}`))
      );
      const next = {};
      types.forEach((t, i) => {
        next[t] = Array.isArray(results[i]?.data?.data) ? results[i].data.data : [];
      });
      setSeriesByType(next);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load document series");
    } finally {
      setSeriesLoading(false);
    }
  };

  useEffect(() => {
    loadSeries();
  }, []);

  const openAddSeries = (type) => {
    setSeriesModalType(type);
    seriesForm.resetFields();
    seriesForm.setFieldsValue({ document_type: type, next_number: 1, is_default: false });
    setSeriesModalOpen(true);
  };

  const submitSeries = async () => {
    try {
      const values = await seriesForm.validateFields();
      await axios.post("document-series", values);
      toast.success("Series added");
      setSeriesModalOpen(false);
      await loadSeries();
    } catch (e) {
      toast.error(e?.response?.data?.error || e?.response?.data?.message || e?.message || "Failed");
    }
  };

  const setDefaultSeries = async (id) => {
    try {
      await axios.patch(`document-series/${id}/default`);
      toast.success("Default updated");
      await loadSeries();
    } catch (e) {
      toast.error("Failed to set default");
    }
  };

  const deleteSeries = async (id) => {
    try {
      await axios.delete(`document-series/${id}`);
      toast.success("Series deleted");
      await loadSeries();
    } catch (e) {
      toast.error(e?.response?.data?.error || "Failed to delete");
    }
  };

  const seriesTable = (type) => {
    const rows = seriesByType?.[type] || [];
    return (
      <>
        <div style={{ marginBottom: 12 }}>
          <Button type="primary" onClick={() => openAddSeries(type)}>Add series</Button>
        </div>
        <Table
          size="small"
          loading={seriesLoading}
          dataSource={rows.map((r) => ({ ...r, key: r.id }))}
          pagination={false}
          columns={[
            { title: "Prefix", dataIndex: "prefix", key: "prefix" },
            { title: "Next number", dataIndex: "next_number", key: "next_number", width: 120 },
            {
              title: "Default",
              key: "is_default",
              width: 100,
              render: (_, r) => (
                <Switch checked={!!r.is_default} onChange={() => setDefaultSeries(r.id)} />
              ),
            },
            {
              title: "Action",
              key: "action",
              width: 140,
              render: (_, r) => (
                <Space>
                  <Button danger size="small" disabled={!!r.is_default} onClick={() => deleteSeries(r.id)}>
                    Delete
                  </Button>
                </Space>
              ),
            },
          ]}
        />
      </>
    );
  };

  const handelChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const { TextArea } = Input;

  return (
    <Fragment>
      <Row className={styles.invoiceSettingPage} gutter={[16, 0]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className={`border rounded column-design ${styles.invoiceSettingCard}`}>
          <Card bordered={false} className={styles.invoiceSettingCardInner}>
            <Title level={4} className={styles.invoiceSettingTitle}>
              Invoice Setting
            </Title>
            {initValues ? (
              <Form
                initialValues={{
                  ...initValues,
                  sale_invoice_prefix: initValues.sale_invoice_prefix || 'INV/25-26/',
                  quotation_prefix: initValues.quotation_prefix || 'QTN/25-26/',
                  challan_prefix: initValues.challan_prefix || 'CHL/25-26/',
                  purchase_invoice_prefix: initValues.purchase_invoice_prefix || 'PINV/25-26/',
                  sale_invoice_terms: initValues.sale_invoice_terms || '',
                  quotation_terms: initValues.quotation_terms || '',
                  challan_terms: initValues.challan_terms || '',
                }}
                form={form}
                name="basic"
                labelCol={{ xs: { span: 24 }, sm: { span: 10 } }}
                wrapperCol={{ xs: { span: 24 }, sm: { span: 14 } }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
              >
                <Tabs
                  defaultActiveKey="company"
                  type="card"
                  activeKey={activeTabKey}
                  onChange={setActiveTabKey}
                  items={[
                    {
                      key: "company",
                      label: "Company Details",
                      children: (
                        <>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Company Name"
                                name="company_name"
                                rules={[{ required: true, message: "Please input Company name!" }]}
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Tagline"
                                name="tag_line"
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Address"
                                name="address"
                                rules={[{ required: true, message: "Please input Address!" }]}
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Phone Number"
                                name="phone"
                                rules={[{ required: true, message: "Please input Phone Number!" }]}
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Email Address"
                                name="email"
                                rules={[{ required: true, message: "Please input Email Address!" }]}
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Website"
                                name="website"
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Terms & Condition"
                                name="terms"
                              >
                                <TextArea rows={4} />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                style={{ marginBottom: "10px" }}
                                label="Company Logo"
                                tooltip="Add or change logo (shown on invoices)"
                              >
                                <Upload
                                  listType="picture-card"
                                  beforeUpload={() => false}
                                  name="image"
                                  fileList={fileList}
                                  maxCount={1}
                                  onChange={handelChange}
                                  accept="image/*"
                                >
                                  {fileList.length >= 1 ? null : (
                                    <div>
                                      <PlusOutlined />
                                      <div style={{ marginTop: 8 }}>Add / Update Logo</div>
                                    </div>
                                  )}
                                </Upload>
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      ),
                    },
                    {
                      key: "bank",
                      label: "Bank Details",
                      children: (
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              label="Account Name"
                              name="account_name"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              label="Bank Name"
                              name="bank_name"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              label="Account Number"
                              name="account_number"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              label="IFSC Code"
                              name="ifsc"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                        </Row>
                      ),
                    },
                    {
                      key: "sale",
                      label: "Sale Invoice",
                      children: (
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            {seriesTable("sale_invoice")}
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              label="Sale Invoice Terms"
                              name="sale_invoice_terms"
                            >
                              <TextArea rows={4} placeholder="Enter terms and conditions for Sale Invoice" />
                            </Form.Item>
                            <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                              <Button
                                type="primary"
                                htmlType="submit"
                                shape="round"
                                loading={loader}
                                onClick={onClickLoading}
                              >
                                Update T&amp;C
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      ),
                    },
                    {
                      key: "quotation",
                      label: "Quotation",
                      children: (
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            {seriesTable("quotation")}
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              label="Quotation Terms"
                              name="quotation_terms"
                            >
                              <TextArea rows={4} placeholder="Enter terms and conditions for Quotation" />
                            </Form.Item>
                            <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                              <Button
                                type="primary"
                                htmlType="submit"
                                shape="round"
                                loading={loader}
                                onClick={onClickLoading}
                              >
                                Update T&amp;C
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      ),
                    },
                    {
                      key: "challan",
                      label: "Challan",
                      children: (
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            {seriesTable("challan")}
                          </Col>
                          <Col xs={24} md={12}>
                            <Form.Item
                              style={{ marginBottom: "10px" }}
                              label="Challan Terms"
                              name="challan_terms"
                            >
                              <TextArea rows={4} placeholder="Enter terms and conditions for Challan" />
                            </Form.Item>
                            <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                              <Button
                                type="primary"
                                htmlType="submit"
                                shape="round"
                                loading={loader}
                                onClick={onClickLoading}
                              >
                                Update T&amp;C
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      ),
                    },
                    {
                      key: "purchase",
                      label: "Purchase Invoice",
                      children: (
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            {seriesTable("purchase_invoice")}
                          </Col>
                          <Col xs={24} md={12}>
                            <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                              <Button
                                type="primary"
                                htmlType="submit"
                                shape="round"
                                loading={loader}
                                onClick={onClickLoading}
                              >
                                Update T&amp;C
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      ),
                    },
                  ]}
                />
                {activeTabKey !== "sale" &&
                  activeTabKey !== "quotation" &&
                  activeTabKey !== "challan" &&
                  activeTabKey !== "purchase" && (
                    <Form.Item style={{ marginTop: 16 }} className={styles.addBtnContainer}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        shape="round"
                        loading={loader}
                        onClick={onClickLoading}
                      >
                        Update Details
                      </Button>
                    </Form.Item>
                  )}
              </Form>
            ) : (
              <Loader />
            )}
          </Card>
        </Col>
      </Row>

      <Modal
        title="Add document series"
        open={seriesModalOpen}
        onCancel={() => setSeriesModalOpen(false)}
        onOk={submitSeries}
        okText="Add"
        destroyOnClose
      >
        <Form form={seriesForm} layout="vertical">
          <Form.Item name="document_type" hidden rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="prefix" label="Prefix" rules={[{ required: true, message: "Prefix is required" }]}>
            <Input placeholder="e.g., INV/25-26/" />
          </Form.Item>
          <Form.Item name="next_number" label="Next number" rules={[{ required: true }]}>
            <Input type="number" min={1} />
          </Form.Item>
          <Form.Item name="is_default" label="Set as default" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AddDetails;
